/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'angle-bracket-right': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M308.982 959.296c-12.035 0-24.061-4.651-33.152-13.927-17.943-18.306-17.647-47.693.662-65.635l376.612-369.106-376.612-369.106c-18.31-17.944-18.605-47.33-.662-65.637 17.944-18.307 47.329-18.601 65.635-.66L751.899 477.48a46.412 46.412 0 010 66.298L341.465 946.029c-9.032 8.851-20.762 13.267-32.483 13.267z"/>'
  }
})
